import {
    Card,
    Autocomplete,
    Button,
    Typography,
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    TextField,
    } from "../../ui";
import React,
    { useEffect,
    useState } from "react";
import ThreeDText from "../../global/ThreeDText";
import {
  getAuthSession,
  getPreUrlAccordingToCart,
  isEmpty,
  isNumberEmpty,
  ItemStatus,
  printDebugLog,
  SUCCESS
} from "../../../constants/constant";
import {
    INITIAL_CATEOGORY_ITEM, INITIAL_CONVERSION_SINGLE_DATA,
    INITIAL_GOLD_INVENTORY_FORM,
    INITIAL_KARAT_INFO
} from "../productConstant";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DeleteIcon from '../../ui/icons/Delete';
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import imageUploadService from "../../../service/imageUploadService";
import { snpAxios } from "../../global/api";
import FileUploadIcon from '../../ui/icons/FileUpload';
import uiUtilInstance from "../../../utilities/uiUtil";
import SnpSwitch from "../../global/SnpSwitch";


const GoldInventory = ({ showSnackbar, setSnpLoader, showDialog, closeDialog, dialogConfig, productProps = {} }) => {

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();

    const [inputValue, setInputValue] = useState('');
    const [listProduct, setListProduct] = useState([]);
    const [listTags, setListTags] = useState([]);


    const [listBrandName, setListBrandName] = useState([]);
    const [listArticleNumber, setListArticleNumber] = useState([]);

    const [karatInfo, setKaratInfo] = useState(INITIAL_KARAT_INFO);
    const [listKaratInfo, setListKaratInfo] = useState([]);
    const [selectedCategory, setSelectedcategory] = useState(INITIAL_CATEOGORY_ITEM);
    const [goldRecords, setGoldRecords] = useState(INITIAL_GOLD_INVENTORY_FORM);

    const [conversionSingleData, setConversionSingleData] = useState(INITIAL_CONVERSION_SINGLE_DATA);
    const [createUnit, setCreateUnit] = useState(false);

    const [imageSelectedError, setImageSelectedError] = useState(false);
    const [uploadedDocument, setUploadedDocument] = useState([]);
    const [selectedImage, setSelectedImage] = useState([]);


    const fireSnackBarMsg = ({ msg, mHorizontal = "right", mVertical = "top", mColor = "#008b8b" }) => {
        showSnackbar(msg, mColor, mVertical, mHorizontal);
    };


    const isValid = () => {
        let isproductInfoValid = true;
        if (!goldRecords.name || !goldRecords.brandName) {
            isproductInfoValid = false;
        }
        return isproductInfoValid;
    }

    const handleProductChange = (event) => {
        const { name, value } = event.target;
        printDebugLog("AddProduct:handleProductChange", name, value);
        if (name === "imgPath") {
            const imageList = event.target.files;
            printDebugLog("imgPath=>", imageList);

            if (imageList && imageList.length > 0) {
                setImageSelectedError(false);

                const newImages = [];
                const newDocuments = [];

                for (let i = 0; i < imageList.length; i++) {
                    const reader = new FileReader();
                    const file = imageList[i];

                    newDocuments.push(file); // Store file references for Uploaded Documents

                    reader.onloadend = function () {
                        newImages.push(reader.result);

                        // Ensure all images are loaded before updating state
                        if (newImages.length === imageList.length) {
                            setSelectedImage((prev) => [...(prev || []), ...newImages]);
                            setUploadedDocument((prev) => [...(prev || []), ...newDocuments]);
                        }
                    };

                    reader.readAsDataURL(file);
                }
            } else {
                setImageSelectedError(true);
            }
        } else {
            setGoldRecords(prev => ({
                ...prev, [name]: value,
            }));
        }
    };

    const handleSelectChange = (event, catg) => {
        //console.log("handleSelectChange", catg);
        if (catg !== null) {
            setSelectedcategory(catg);
        } else {
            setSelectedcategory(productProps.selectedCategory ?? INITIAL_CATEOGORY_ITEM);
        }
    };

    const handleSelectProduct = (event, row) => {
        if (row !== null) {
            if (isEmpty(row.id)) {
                printDebugLog("handleSelectProduct ", event.target.name, row);
                setGoldRecords(prev => ({
                    ...prev,
                    [event.target.name]: row,
                }))
            } else {
                setGoldRecords({
                    ...row,
                });
                setSelectedcategory(prev => ({
                    ...prev,
                    catgId: row.catgId,
                    catgName: row.catgName,
                    inventoryType: row.inventoryType,
                    inventoryTypeStr: row.inventoryTypeStr,
                }))
            }
        } else {
            setGoldRecords(INITIAL_GOLD_INVENTORY_FORM);
        }
    }

    const handleSelectProductChild = (name, row) => {
        printDebugLog("handleSelectProductChild", name + "->" + row);
        if (row !== null) {
            setGoldRecords(prev => ({
                ...prev,
                id: "",
                [name]: row,
            }))
        } else {
            setGoldRecords(prev => ({
                ...prev,
                id: "",
                [name]: "",
            }))
        }
    }

    const handleSelectTags = (event, newValue, reason, detail) => {
        printDebugLog("Autocomplete", event.key, newValue, reason, detail);
        setInputValue('');
        if (reason === 'removeOption') {
            setGoldRecords(prev => ({
                ...prev,
                tags: prev.tags.filter(i => i !== detail.option),
            }));
        } else if (reason === 'selectOption' || reason === 'createOption') {
            setGoldRecords((prev) => ({
                ...prev,
                tags: newValue,
            }));
        } else if (reason === 'clear') {
            setGoldRecords((prev) => ({
                ...prev,
                tags: [],
            }));
        }
    };

    const handleItemSearchChange = (event) => {
        if (event) {
            if (event.target.name === 'tags') {
                setInputValue(event.target.value);
            }
        }
    };

    const handleKeyDownTags = (evt) => {
        printDebugLog("handleKeyDownTags key", evt?.key);
        if (["Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            printDebugLog("handleKeyDownTags inputValue", inputValue);
            if (!isEmpty(inputValue)) {
                setListTags([]);
                const list = goldRecords.tags === undefined ? [inputValue] : [...goldRecords.tags, inputValue];
                setGoldRecords(prev => ({
                    ...prev,
                    tags: list,
                }));
                setInputValue('');
            }
        }
    };

    const handleSearchTags = (event) => {
        const { name, value } = event.target;
        //printDebugLog("handleSearchTags", name);
        if (value.length >= 3) {
            fetchAutoCompleteDetails(name, value);
        }
    };

    const handleSearchHsnCodeBrandName = (event, length) => {
        const { name, value } = event.target;
        printDebugLog("handleSearchHsnCodeBrandName", name, value, goldRecords);
        setGoldRecords(prev => ({
            ...prev,
            [name]: value,
        }))
        //printDebugLog("handleSearchTags", name);
        if (value.length >= length) {
            fetchAutoCompleteDetails(name, value);
        }
    };

    const handleConversionChange = (event, option) => {
        if (option != null) {
            // console.log("handleConversionChange", option);
            if (option.id === "cr") {
                setConversionSingleData(INITIAL_CONVERSION_SINGLE_DATA);
                setCreateUnit(true);
            } else {
                if (createUnit) {
                    setCreateUnit(false);
                }
                setConversionSingleData(option);
            }
        } else {
            setCreateUnit(false);
            setConversionSingleData(option);
        }
    };

    const handleSetKartaInfoChange = (event, option) => {
        setKaratInfo(option);
    };



    const handleCoversionUpdate = (event) => {
        const { name, value } = event.target;
        //console.log("handleCoversionUpdate", name, value);
        if (name === 'unitRestrictions') {
            const previousCheckedValue = conversionSingleData.unitRestrictions;
            setConversionSingleData(prev => ({
                ...conversionSingleData,
                unitRestrictions: !previousCheckedValue,
            }));
        } else if (name === 'decimalSmRestrictions') {
            const previousCheckedValue = conversionSingleData.decimalSmRestrictions;
            setConversionSingleData(prev => ({
                ...conversionSingleData,
                decimalSmRestrictions: !previousCheckedValue,
            }));
        } else if (name === 'smallUnitCount') {
            if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                setConversionSingleData(prev => ({
                    ...conversionSingleData,
                    smallUnitCount: value,
                }));
            }
        } else {
            if (value === "" || /^[a-zA-Z]*$/.test(value)) {
                setConversionSingleData(prev => ({
                    ...conversionSingleData,
                    [name]: value,
                }));
            }
        }
    };

    const handleDeleteInternalImage = (index) => {
        printDebugLog("handleDeleteInternalImage", index);
        setSelectedImage((prev) => prev.filter((_, i) => i !== index));
        setUploadedDocument((prev) => prev.filter((_, i) => i !== index));
    };

    const fetchAutoCompleteDetails = async (id, regextStr) => {
        const cartTypeStr = getPreUrlAccordingToCart(storeActiveShopHash.cartType);
        let urlType = "";
        const version = 2;
        if (id === 'tags') {
            urlType = `search-composition?q=${regextStr}&m=${storeActiveShopHash.cartType}&v=${version}`;
        } else if (id === 'articleNumber') {
            urlType = `search-hsn-code?q=${regextStr}&m=${storeActiveShopHash.cartType}&s=${storeActiveShopHash.id}`;
        } else if (id === 'brandName') {
            urlType = `search-brand-name?q=${regextStr}&m=${storeActiveShopHash.cartType}&s=${storeActiveShopHash.id}`;
        }
        try {
            const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}${cartTypeStr}${urlType}`;
            const response = await axios.get(fetchBillUrl);
            printDebugLog("fetchAutoCompleteDetails   => ", regextStr, response.data);
            if (!isEmpty(response.data)) {
                if (id === 'tags') {
                    setListTags(response.data);
                } else if (id === 'articleNumber') {
                    setListArticleNumber(response.data);
                } else if (id === 'brandName') {
                    setListBrandName(response.data);
                }

            } else {
                if (id === 'tags') {
                    setListTags([]);
                } else if (id === 'articleNumber') {
                    setListArticleNumber([]);
                } else if (id === 'brandName') {
                    setListBrandName([]);
                }

            }

        } catch (error) {
            console.error("fetchAutoCompleteDetails errr ", error);
            if (id === 'tags') {
                setListTags([]);
            } else if (id === 'articleNumber') {
                setListArticleNumber([]);
            } else if (id === 'brandName') {
                setListBrandName([]);
            }
        }
    };

    const handleDeleteImage = async (index) => {
        try {
            const path = goldRecords.images[index];
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}delete-image-gold?productHash=${goldRecords.id}&path=${path}`;
            printDebugLog("handleDeleteImage<=", cUrl);
            setSnpLoader(true);
            const response = await axios.get(cUrl);
            if (response.data.status === SUCCESS) {
                if (index !== -1) {
                    const images = goldRecords.images;
                    const updatedItems = [...images.slice(0, index), ...images.slice(index + 1)];
                    setGoldRecords(prev => ({
                        ...prev,
                        images: updatedItems,
                    }));
                    fireSnackBarMsg({ msg: "Image removed successfull ... Updating Items" });
                }
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("handleDeleteImage", error);
            setSnpLoader(false);
        }
    };

    const getListKaratInfo = async () => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-karat-info?type=Gold`;
            setSnpLoader(true);
            const response = await axios.get(cUrl);
            if (response.data.status === SUCCESS) {
                setListKaratInfo(response.data.jcJson.fullData ?? []);
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("getListKaratInfo", error);
            setSnpLoader(false);
        }
    };

    const handleSaveProduct = async () => {
        if (isEmpty(conversionSingleData.id) && !createUnit) {
            fireSnackBarMsg({ msg: "Custom Unit Type Cannot be empty" });
            return;
        }
        if (createUnit && !conversionSingleData.unitRestrictions && isNumberEmpty(conversionSingleData.smallUnitCount)) {
            fireSnackBarMsg({ msg: "Empty Small Count for Custom Unit" });
            return;
        }
        if (isEmpty(selectedCategory.catgId)) {
            fireSnackBarMsg({ msg: "Cateogory cannot be empty" });
            return;
        }
        if (isEmpty(karatInfo.id)) {
            fireSnackBarMsg({ msg: "KaratInfo cannot be empty" });
            return;
        }
        setSnpLoader(true);
        setSelectedImage([]);
        setUploadedDocument([]);

        const catgUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}persist-gold-inventory`;
        const filledData = {
            jcJson: {
                apiToken: getAuthSession().apiToken,
                shopHash: storeActiveShopHash.id,
                id: goldRecords.id,
                cnvId: conversionSingleData.id,
                catgId: selectedCategory.catgId,
                catgName: selectedCategory.catgName,
                tags: goldRecords.tags,
                itemStatus: Number(goldRecords.itemStatus),
                name: goldRecords.name,
                brandName: goldRecords.brandName,
                articleNumber: goldRecords.articleNumber,
                images: goldRecords.images,
                aboutItem: goldRecords.aboutItem,
                unitName: conversionSingleData.unitName,
                smallUnitCount: parseFloat(conversionSingleData.smallUnitCount),
                unitCount: Number(conversionSingleData.unitCount),
                smallUnitName: conversionSingleData.smallUnitName,
                unitRestrictions: conversionSingleData.unitRestrictions,
                decimalSmRestrictions: conversionSingleData.decimalSmRestrictions,
                karatId: karatInfo.id,
                showBrandName: goldRecords.showBrandName,
            }
        };
        //console.log("handleProductEntry => ", filledData);
        snpAxios.post(
            catgUrl,
            filledData
        ).then(response => {
            printDebugLog("handleSaveProduct:responses => ", response.data);
            setSnpLoader(false);
            if (response.data.status === SUCCESS) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    positiveReq: true,
                    positiveAction: "Ok!",
                    handleSubmit: () => {
                        setGoldRecords(prev => ({
                            ...prev, id: response.data.jcJson.id,
                        }))
                        closeDialog();
                    },
                    negativeAction: "Go back!", subTitle: "Records updated Successfully",
                    handleClose: () => {
                        closeDialog();
                        navigate("/dashboard/showproduct");
                    },
                });
            }
        }).catch(error => {
            console.error("handleSaveProduct : ", error);
            // window.location.href = "#/error";
            setSnpLoader(false);
        });
    };

    const handleImageUpload = async () => {
        printDebugLog("handleImageUpload", goldRecords);
        if (isEmpty(conversionSingleData.id) && !createUnit) {
            fireSnackBarMsg({ msg: "Custom Unit Type cannot be null" });
            return;
        }
        if (isEmpty(karatInfo.id)) {
            fireSnackBarMsg({ msg: "KaratInfo cannot be empty" });
            return;
        }
        if (!isValid()) {
            return;
        }
        let isError = false;
        // if (!uploadedDocument || uploadedDocument.size > 5242880 || !(uploadedDocument.type.includes("image"))) {    //5248256
        //   setImageSelectedError(true);
        //   isError = true;
        // }
        if (!uploadedDocument || uploadedDocument.length === 0) {
            isError = true;
        }
        if (!isError) {
            setSnpLoader(true);
            for (let i = 0; i < uploadedDocument.length; i++) {
                let formData = new FormData();
                formData.append('fnm', getAuthSession().apiToken);
                formData.append("file", uploadedDocument[i]);
                await imageUploadService.upload(storeApiUrl.BACKEND_BASE_URL, getPreUrlAccordingToCart(storeActiveShopHash.cartType), formData).then(response => {
                    if (response.data.folderName) {
                        printDebugLog("folderName", response.data.folderName);
                        if (!goldRecords.images) {
                            goldRecords.images = [];
                        }
                        goldRecords.images.push(response.data.folderName);
                        if (i === uploadedDocument.length - 1) {
                            handleSaveProduct();
                        }
                    }
                }
                ).catch(error => {
                    handleSaveProduct();
                    console.error("handleImageUpload = > ", error);
                    // window.location.href = "#/error";
                });
            }
        } else {
            handleSaveProduct();
        }
    };

    const deleteProduct = async () => {
        try {
            setSnpLoader(true);
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}gold-inventory-delete?deleteId=${goldRecords.id}&token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cUrl);
            if (response.data.status === SUCCESS) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    positiveAction: "Create new!",
                    handleSubmit: () => {
                        setGoldRecords(INITIAL_GOLD_INVENTORY_FORM);
                    },
                    negativeAction: "Go back!", subTitle: "Product deleted successfully",
                    handleClose: () => {
                        closeDialog();
                        navigate("/dashboard/showproduct");
                    },
                });

            }
            setSnpLoader(false);
        } catch (error) {
            setSnpLoader(false);
            console.error("deleteProduct", goldRecords.id, error);
        }
    };

    const getProductDetails = async (e, optPage = 0, optTotal = 0) => {
        const { name, value } = e.target;
        setGoldRecords(prev => ({
            ...prev,
            [name]: value,
        }))
        try {
            if (value && value.length > 2) {
                const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-gold-inventory?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}&stock=${value}&page=${optPage}&total=${optTotal}`;
                const response = await axios.get(cartUrl);
                if (response.data.status === SUCCESS) {
                    const payLoad = response.data.jcJson;
                    setListProduct(payLoad.fullData ?? []);
                } else {
                    setListProduct([]);
                }
            }
        } catch (error) {
            console.error("getProductDetails", value, optPage, optTotal, error);
            setListProduct([]);
        }
    };

    useEffect(() => {
        getListKaratInfo();
        printDebugLog("GoldInventory, productProps", productProps);
        const mPrdInfo = productProps.productInfo ?? INITIAL_GOLD_INVENTORY_FORM;
        setGoldRecords(mPrdInfo);
        setKaratInfo(productProps.karatInfo ?? INITIAL_KARAT_INFO);
        setConversionSingleData(productProps.conversionSingleData ?? INITIAL_CONVERSION_SINGLE_DATA);
        setSelectedcategory(productProps.selectedCategory ?? INITIAL_CATEOGORY_ITEM);
    }, [storeActiveShopHash, storeApiUrl])

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <ThreeDText
                    text="Item Information"
                    display=""
                    className="three-d-text-container"
                    justifyContent="left"
                    alignItems="left" />
            </Grid>
            <Grid item xs={12}>
                <Paper elevation={10}
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "#FEF7DA",
                        boxShadow: 1,
                        borderRadius: 4,
                        padding: 1,
                    }} ><Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Grid container spacing={1}>
                                <Grid item md={3} sm={4} lg={3} xs={12}>
                                    <input
                                        accept="image/*"
                                        id="imgPath"
                                        name="imgPath"
                                        type="file"
                                        multiple={5}
                                        onChange={handleProductChange}
                                        style={{ display: "none" }}
                                    />
                                    <label htmlFor="imgPath">
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            startIcon={<FileUploadIcon />}
                                            style={{ textTransform: "none", borderRadius: "8px" }}
                                        >
                                            Upload Product Image
                                        </Button>
                                    </label>
                                </Grid>
                                {
                                    (selectedImage && (selectedImage?.length ?? 0) > 0) &&
                                    selectedImage.map((item, index) => (
                                        <Card orientation="horizontal" size="md" key={"Image_" + index} variant="outlined">
                                            <img
                                                alt={"Image_" + index}
                                                style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                                                // src={storeApiUrl.BACKEND_BASE_URL + "files/" + imgv}
                                                src={item}
                                            />
                                            <DeleteIcon
                                                onClick={() => handleDeleteInternalImage(index)} />

                                        </Card>

                                    ))
                                }
                                {
                                    (goldRecords?.images?.length ?? 0) > 0 && goldRecords.images.map((item, index) => (
                                        <Card orientation="horizontal" size="md" key={"Image_" + index} variant="outlined">
                                            <img
                                                style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                                                srcSet={`${storeApiUrl.BACKEND_BASE_URL + "files/" + item}`}
                                                src={`${storeApiUrl.BACKEND_BASE_URL + "files/" + item}`}
                                                alt={"Image_" + index}
                                            />
                                            {
                                                goldRecords.images.length > 1 && <DeleteIcon
                                                    onClick={() => handleDeleteImage(index)} />
                                            }

                                        </Card>

                                    ))
                                }
                            </Grid>
                        </Grid>
                        {imageSelectedError &&
                            <Grid container sx={{
                                mb: 1,
                            }}>
                                <Grid item xs zeroMinWidth>
                                    <Typography variant="p" color="#EE4B2B" noWrap>Please select the Image (image format) having size below 5Mb</Typography>
                                    <br />
                                    <Typography variant="p" color="#EE4B2B" noWrap>before uploading.</Typography>
                                </Grid></Grid>

                        }
                        <Grid item md={6} xs={12} sm={6} lg={6}>
                            <Autocomplete id="prdName"
                                freeSolo
                                disabled={productProps.isEditProduct}
                                options={listProduct}
                                autoHighlight
                                size="small"
                                variant="filled"
                                fullWidth
                                value={goldRecords}
                                onChange={handleSelectProduct}
                                onBlur={(e) => setListProduct([])}
                                getOptionLabel={(option) => option ? option?.name : ''}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        key={option.id}
                                    >
                                        {option.name}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="name"
                                        label="Search/Enter Item"
                                        onChange={(e) => getProductDetails(e)}
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} xs={12} sm={6} lg={6}>
                            <Autocomplete id="articleNumber"
                                freeSolo
                                disabled={productProps.isEditProduct}
                                options={listArticleNumber}
                                autoHighlight
                                size="small"
                                name="articleNumber"
                                variant="filled"
                                fullWidth
                                value={goldRecords.articleNumber}
                                onChange={(e, row) => handleSelectProductChild("articleNumber", row)}
                                onBlur={(e) => setListArticleNumber([])}
                                getOptionLabel={(option) => option || ''}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="articleNumber"
                                        label="Search/Enter Article No"
                                        onChange={(e) => handleSearchHsnCodeBrandName(e, 2)}
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} xs={12} sm={6} lg={6}>
                            <Autocomplete id="brandName"
                                name="brandName"
                                freeSolo
                                disabled={productProps.isEditProduct}
                                options={listBrandName}
                                autoHighlight
                                size="small"
                                variant="filled"
                                fullWidth
                                value={goldRecords.brandName}
                                onChange={(e, row) => handleSelectProductChild("brandName", row)}
                                onBlur={(e) => setListBrandName([])}
                                getOptionLabel={(option) => option || ''}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="brandName"
                                        label="Search/Enter Brand Name"
                                        onChange={(e) => handleSearchHsnCodeBrandName(e, 3)}
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} sm={6} lg={6} xs={12} >
                            <Autocomplete
                                id="cateogory-select"
                                disabled={productProps.isEditProduct}
                                options={productProps.categoryData || []}
                                autoHighlight
                                onChange={handleSelectChange}
                                size="small"
                                variant="filled"
                                fullWidth
                                getOptionLabel={(option) => option.catgName}
                                value={selectedCategory}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option.catgName}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Choose a category"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} sm={6} lg={6} xs={12}>
                            <Autocomplete
                                id="karat-select"
                                size="small"
                                disabled={!isEmpty(goldRecords.id) && (productProps.isEditProduct || false)}
                                options={listKaratInfo}
                                onChange={handleSetKartaInfoChange}
                                fullWidth
                                getOptionLabel={(option) => option?.details ?? ''}
                                value={karatInfo}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        sx={{
                                            border: "1px solid lightgrey", // light grey border
                                            borderRadius: "4px",           // optional: rounded corners
                                            padding: "1px",
                                        }}
                                    >
                                        {uiUtilInstance.getKaratLabel(option)}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Karat Info"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item md={6} sm={6} lg={6} xs={12}>
                            <Autocomplete
                                id="cnv-select"
                                size="small"
                                disabled={!isEmpty(goldRecords.id) && (productProps.isEditProduct || false)}
                                options={productProps.conversionTypeData || []}
                                onChange={handleConversionChange}
                                fullWidth
                                getOptionLabel={(option) => option?.cnvDetails || ''}
                                value={conversionSingleData}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        sx={{
                                            border: "1px solid lightgrey", // light grey border
                                            borderRadius: "4px",           // optional: rounded corners
                                            padding: "1px",
                                            ...(option.id === 'cr' && {
                                                background: '#0770c1',
                                                fontWeight: 'bold',
                                                '&:hover': {
                                                    background: '#0770c1', // keep same on hover
                                                },
                                            }),
                                        }}
                                    >
                                        {option?.cnvDetails}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Custom Unit Type"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        {
                            createUnit &&
                            <Grid item xs={12}>
                                <Grid container spacing={1} justifyContent="center"
                                    alignItems="center">
                                    <Grid item md={6} sm={6} lg={6} xs={12}>
                                        <TextField
                                            required
                                            id="unitName"
                                            label="Enter Unit Name"
                                            name="unitName"
                                            variant="filled"
                                            size="small"
                                            value={conversionSingleData.unitName}
                                            onChange={handleCoversionUpdate}
                                        />
                                    </Grid>
                                    <Grid item md={6} sm={6} lg={6} xs={12}>
                                        <FormControlLabel control={<Checkbox checked={conversionSingleData.unitRestrictions}
                                            onChange={handleCoversionUpdate} id="unitRestrictions" />} name="unitRestrictions" label="Unit Restrictions" />
                                    </Grid>
                                    <Grid item md={6} sm={6} lg={6} xs={12}>
                                        <TextField
                                            required
                                            id="smallUnitCount"
                                            variant="filled"
                                            size="small"
                                            label="Enter Small Unit Count"
                                            name="smallUnitCount"
                                            value={conversionSingleData.smallUnitCount}
                                            onChange={handleCoversionUpdate}
                                        />
                                    </Grid>
                                    <Grid item md={6} sm={6} lg={6} xs={12}>
                                        <TextField
                                            required
                                            variant="filled"
                                            size="small"
                                            id="smallUnitName"
                                            label="Enter Small Unit Name"
                                            name="smallUnitName"
                                            value={conversionSingleData.smallUnitName}
                                            onChange={handleCoversionUpdate}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel control={<Checkbox checked={conversionSingleData.decimalSmRestrictions}
                                            onChange={handleCoversionUpdate} id="decimalSmRestrictions" />} name="decimalSmRestrictions"
                                            label=
                                            {<p>Disable Fraction{"(Eg."} <span style={{ textDecoration: "line-through" }}> 0.5 {conversionSingleData.unitName}</span>{" 5 " + conversionSingleData.smallUnitName + " )"}</p>}

                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        <Grid item md={6} sm={6} lg={6} xs={12}>
                            <Autocomplete id="tags"
                                multiple
                                freeSolo
                                options={listTags}
                                autoHighlight
                                size="small"
                                variant="filled"
                                fullWidth
                                value={goldRecords.tags ?? []}
                                onChange={handleSelectTags}
                                onBlur={(e) => setListTags([])}
                                getOptionLabel={(option) => option || ''}
                                inputValue={inputValue}
                                onInputChange={handleItemSearchChange}
                                onKeyDown={handleKeyDownTags}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="tags"
                                        label="Enter Tags"
                                        onChange={handleSearchTags}
                                        helperText="Use Enter/Tab/Comma(,) to add"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                id="aboutItem"
                                name="aboutItem"
                                variant="filled"
                                size="small"
                                onChange={handleProductChange}
                                multiline={true}
                                rows={3}
                                maxRows={5}
                                label="Enter About Item"
                                value={goldRecords.aboutItem}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <SnpSwitch
                                leftLabel="Hide Brand Name"
                                rightLabel="Show Brand Name"
                                checked={goldRecords.showBrandName}
                                onChange={(e) => setGoldRecords(prev => ({
                                    ...prev, showBrandName: !prev.showBrandName,
                                }))}
                                color="primary"
                                spacing={2}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Item Status</FormLabel>
                                <RadioGroup aria-label="itemStatus" name="itemStatus" value={goldRecords.itemStatus} onChange={handleProductChange} row={true}>

                                    <FormControlLabel value={ItemStatus.ACTIVE} control={<Radio />} label="Active" />
                                    <FormControlLabel value={ItemStatus.INACTIVE} control={<Radio />} label="InActive" />

                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {
                            !isEmpty(goldRecords.id) &&
                            <Grid item xs={6}>
                                <SnpButton variant="contained" mbgcolor="#0073ae" onPointerDown={() => {
                                    navigate("/dashboard/goldsupplierrecord", { state: { inventoryId: goldRecords.id } });
                                }}>
                                    Supplier Records
                                </SnpButton>
                            </Grid>
                        }
                        {
                            !isEmpty(goldRecords.id) &&
                            <Grid item xs={6}>
                                <SnpButton variant="contained" mbgcolor="#0073ae" onPointerDown={() => {
                                    navigate("/dashboard/showgoldsupplierrecord", { state: { inventoryId: goldRecords.id } });
                                }}>
                                    Show All Records
                                </SnpButton>
                            </Grid>
                        }
                    </Grid>
                </Paper>
            </Grid>


            <Grid item xs={12} md={6} sm={6} lg={6}>
                <SnpButton variant="contained" mbgcolor={(productProps.isEditProduct || false) ? "#764032" : "#01333e"} onPointerDown={() => handleImageUpload()}>
                    {!isEmpty(goldRecords.id) ? "Update" : "Create"}
                </SnpButton>
            </Grid>
            <Grid item xs={12} md={6} sm={6} lg={6}>
                <DismissButton variant="contained" onPointerDown={() => navigate("/dashboard/showproduct")}>
                    Dismiss
                </DismissButton>
            </Grid>
            {
                !isEmpty(goldRecords.id) &&
                <Grid item xs={12}>
                    <SnpButton variant="contained" color="bRed" onPointerDown={() => deleteProduct()}>
                        Delete Product
                    </SnpButton>
                </Grid>
            }
        </Grid >
    )
};

export default React.memo(GoldInventory);